import {bellRemoteConstants, dashboardConstants} from "../../constants/ApiConstant";
import Axios from "../../axios.js";
import {playEmergencyBellFromFrontend} from "../../utils/EmergencyBellPlayer";

export async function toggleBellSwitch(params) {
    return Axios.post(bellRemoteConstants.BELL_SWITCH, params);
}

export async function playEmergencyBell(params) {
    return playEmergencyBellFromFrontend(params?.emergencyType);
}

export async function fetchDashboardTiles() {
    return Axios.get(dashboardConstants.FETCH_DASHBOARD_TILES);
}

export async function fetchDashboardDonutChart() {
    return Axios.get(dashboardConstants.FETCH_DASHBOARD_DONUT_CHART);
}

// Admin sales overview for the dashboard line chart. Backend returns
// { numbers: [...], months: [...] } where months are the x-axis labels and
// numbers are the matching values for the (web) series.
export async function fetchSalesOverview() {
    return Axios.get(dashboardConstants.FETCH_SALES_OVERVIEW);
}
